/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_DessertInputs */

const en_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dessert`)
};

const es_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postre`)
};

const fr_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dessert`)
};

const de_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dessertwein`)
};

const ja_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デザートワイン`)
};

const zh_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`甜点酒`)
};

const ar_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبيذ للحلوى`)
};

const id_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidangan Penutup`)
};

const it_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vino da Dessert`)
};

const ru_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Десертное`)
};

const pt_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobremesa`)
};

const ko_val_dessert = /** @type {(inputs: Val_DessertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디저트`)
};

/**
* | output |
* | --- |
* | "Dessert" |
*
* @param {Val_DessertInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_dessert = /** @type {((inputs?: Val_DessertInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_DessertInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_dessert(inputs)
	if (locale === "es") return es_val_dessert(inputs)
	if (locale === "fr") return fr_val_dessert(inputs)
	if (locale === "de") return de_val_dessert(inputs)
	if (locale === "ja") return ja_val_dessert(inputs)
	if (locale === "zh") return zh_val_dessert(inputs)
	if (locale === "ar") return ar_val_dessert(inputs)
	if (locale === "id") return id_val_dessert(inputs)
	if (locale === "it") return it_val_dessert(inputs)
	if (locale === "ru") return ru_val_dessert(inputs)
	if (locale === "pt") return pt_val_dessert(inputs)
	return ko_val_dessert(inputs)
});